export default "__VITE_ASSET__BcaDOy9U__"